/**
 * Alerts
 */

/** Modal code */
let modal;

//Function to close the modal
function closeModal() {
	if(modal){
		$(modal).modal('hide')  //Hides the modal
		let garbage = document.querySelector('.modal')  //Grabs any remaining tags with class modal
		garbage.remove()  //removes remaining tags completely
	}
};

//Function to call the normal 2 button modal
function normalModal() {
	//Get active order ID
	let activeOrder = $('#active_order').attr('data-order_id');
	//Grab div element to insert modal before
	let demoContainer= document.querySelector("#app");

	//The following creates the modal
	modal = document.createElement('div');
	modal.classList.add('modal');
	modal.classList.add('fade');
	modal.setAttribute('id', 'normalModal');
	modal.setAttribute('tabindex', '-1');
	modal.setAttribute('role', 'dialog');
	modal.setAttribute('aria-labelledby', 'normalModalLabel');

	let modalDialogArea = document.createElement('div');
	modalDialogArea.classList.add('modal-dialog');
	modalDialogArea.classList.add('modal-dialog-centered');
	modalDialogArea.classList.add('modal-sm');
	modalDialogArea.setAttribute('role', 'document');
	modal.appendChild(modalDialogArea);

	let modalContent = document.createElement('div');
	modalContent.classList.add('modal-content');
	modalDialogArea.appendChild(modalContent);
	//Modal header area
	let modalHeader = document.createElement('div');
	modalHeader.classList.add('modal-header');
	modalContent.appendChild(modalHeader);
	//Modal header content
	let modalTitle = document.createElement('h5');
	modalTitle.classList.add('modal-title');
	modalTitle.setAttribute('id', 'normalModalLabel');
	modalTitle.textContent = 'Selection Added';
	modalHeader.appendChild(modalTitle);

	//Creates the close x in upper right of the modal
	let modalCloseButton = document.createElement('button');
	modalCloseButton.setAttribute('type', 'button');
	modalCloseButton.classList.add('close');
	modalCloseButton.setAttribute('aria-label', 'Close');
	modalCloseButton.addEventListener('click', closeModal);
	modalHeader.appendChild(modalCloseButton);
	let modalSpan = document.createElement('span');
	modalSpan.setAttribute('aria-hidden', 'true');
	modalSpan.innerHTML = '&times;';
	modalCloseButton.appendChild(modalSpan);

	//Text content area of modal
	let modalBody = document.createElement('div');
	modalBody.classList.add('modal-body');
	modalBody.textContent = 'Your selection was added to your order!!';
	modalContent.appendChild(modalBody);

	//Modal footer
	let modalFooter = document.createElement('div');
	modalFooter.classList.add('modal-footer');
	modalContent.appendChild(modalFooter);

	//Creates checkout button
	let modalCheckoutButton = document.createElement('button');
	modalCheckoutButton.setAttribute('id', 'checkOut')
	modalCheckoutButton.setAttribute('type', 'button');
	modalCheckoutButton.classList.add('button');
	modalCheckoutButton.classList.add('badge-pill');
	modalCheckoutButton.classList.add('badge-secondary');
	modalCheckoutButton.classList.add('ml-3');
	modalCheckoutButton.textContent = 'Checkout';
	modalCheckoutButton.addEventListener('click', function(){
		window.location.href= "/orders/"+ activeOrder+'/check_out'
	} );
	modalFooter.appendChild(modalCheckoutButton);

	//creates Add More items button
	let modalAddButton = document.createElement('button');
	modalAddButton.setAttribute('id', 'addItem');
	modalAddButton.setAttribute('type', 'button');
	modalAddButton.classList.add('button');
	modalAddButton.classList.add('badge-pill');
	modalAddButton.classList.add('badge-primary');
	modalAddButton.classList.add('ml-3');
	modalAddButton.classList.add('modifier-product');
	modalAddButton.textContent = 'Add more items';
	modalAddButton.addEventListener('click', function(){
		closeModal();

	});
	modalFooter.appendChild(modalAddButton);

	//Grabs the parent element of the div container and inserts modal before it.
	demoContainer.parentElement.insertBefore(modal, demoContainer);

	//Opens the modal for user to see
	$("#normalModal").modal('show');
	// };

};

//Function to call the alert modal
function alertModal(alertMessage) {
	let message = alertMessage;
	let mainEleChild = document.getElementsByTagName('MAIN')[0].firstElementChild.id
	let demoContainer = document.getElementById(mainEleChild);

	//The following creates the modal
	modal = document.createElement('div');
	modal.classList.add('modal');
	modal.classList.add('fade');
	modal.setAttribute('id', 'alertModal');
	modal.setAttribute('tabindex', '-1');
	modal.setAttribute('role', 'dialog');
	modal.setAttribute('aria-labelledby', 'alertModalLabel');
	let modalDialogArea = document.createElement('div');
	modalDialogArea.classList.add('modal-dialog');
	modalDialogArea.classList.add('modal-dialog-centered');
	modalDialogArea.classList.add('modal-sm');
	modalDialogArea.setAttribute('role', 'document');
	modal.appendChild(modalDialogArea);
	let modalContent = document.createElement('div');
	modalContent.classList.add('modal-content');
	modalDialogArea.appendChild(modalContent);
	let modalHeader = document.createElement('div');
	modalHeader.classList.add('modal-header');
	modalContent.appendChild(modalHeader);
	let modalTitle = document.createElement('h5');
	modalTitle.classList.add('modal-title');
	modalTitle.setAttribute('id', 'exampleModalLabel');
	modalTitle.textContent = 'Attention!';
	modalHeader.appendChild(modalTitle);
	let modalCloseButton = document.createElement('button');
	modalCloseButton.setAttribute('type', 'button');
	modalCloseButton.classList.add('close');
	modalCloseButton.setAttribute('aria-label', 'Close');
	modalCloseButton.addEventListener('click', closeModal);
	modalHeader.appendChild(modalCloseButton);
	let modalSpan = document.createElement('span');
	modalSpan.setAttribute('aria-hidden', 'true');
	modalSpan.innerHTML = '&times;';
	modalCloseButton.appendChild(modalSpan);
	let modalBody = document.createElement('div');
	modalBody.classList.add('modal-body');
	modalBody.textContent = message;
	modalContent.appendChild(modalBody);
	let modalFooter = document.createElement('div');
	modalFooter.classList.add('modal-footer');
	modalContent.appendChild(modalFooter);

	let modalAddButton = document.createElement('button');
	modalAddButton.setAttribute('type', 'button');
	modalAddButton.classList.add('button');
	modalAddButton.classList.add('badge-pill');
	modalAddButton.classList.add('badge-primary');
	modalAddButton.classList.add('ml-3');
	modalAddButton.textContent = 'OK';
	modalAddButton.addEventListener('click', closeModal);
	modalFooter.appendChild(modalAddButton);

	demoContainer.appendChild(modal);

	//Opens the modal for user to see
	$("#alertModal").modal('show');

};

function testModal(alertMessage){
	$( "#dialog" ).dialog();
}

export {alertModal, testModal};

	//**************  END MODAL CODE    ***************************** */

